<template>
  <loading v-if="loading" />

  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>手術清單</p>
          <span></span>
        </div>
        <a class="arr" v-if="detail" @click="detail = null"
          ><div class="inner"></div
        ></a>
      </div>
    </div>

    <div v-if="detail" class="content">
      <div class="detail__item" v-for="(value, title) in detail" :key="title">
        <div class="item__title">{{ title }}：</div>
        <div class="item__data">
          <div class="item__value">{{ value }}</div>
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div v-if="operations.length">
        <div
          class="operationBox"
          style="margin-bottom: .618rem;"
          v-for="(o, idx) in operations"
          :key="idx"
          @click="detail = o"
        >
          <div class="circleBox column--central text--central">
            <div>{{ dayjs(o.預約日期).format("MM/DD") }}</div>
            <small>{{ dayjs(o.預約日期).format("YYYY") }}</small>
          </div>
          <div class="column--central text--central">
            <div style="margin: .382rem 0">{{ o.姓名 }}-{{ o.病歷號 }}</div>
            <div style="margin: .191rem 0;">
              {{ o.手術方式 }}
            </div>
          </div>
          <div class="column--central text--central" style="padding: .618rem;">
            <div style="margin: .382rem 0;">
              {{ o.主刀醫師 }}
            </div>
            <div style="margin: .191rem 0;">
              {{ dayjs(o.預約時間, "HHmm").format("HH:mm") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>
</template>

<script>
import api from "../../api/index";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export default {
  data() {
    return {
      loading: false,
      comfirm: {},
      modal: {},
      operations: [],
      detail: null,
      message: null
    };
  },
  created() {
    this.getOperations();
  },
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  methods: {
    dayjs,
    getOperations() {
      this.loading = true;
      api.operation
        .query({
          jwt: this.member.jwt
        })
        .then(data => {
          console.log(data);
          this.operations = data.operations;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  }
};
</script>

<style lang="css" scoped>
.operationBox {
  display: grid;
  justify-content: space-between;
  grid-auto-flow: column;
  border-radius: 100rem;
  border: 1px solid #f19e4e;
}
.circleBox {
  width: 4.618rem;
  height: 4.618rem;
  border-radius: 50%;
  border: 1px solid #f19e4e;
}
.column--central {
  align-content: center;
}
.row--central {
  justify-content: center;
  grid-auto-flow: column;
}
.text--central {
  text-align: center;
}
.detail__item {
  border-bottom: dashed 1px #f19e4e;
  padding: 0.75rem 0;
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.detail__item--note {
  color: #ff4664;
}
.detail__item .item__title {
  display: grid;
  align-content: center;
  font-size: 1.25rem /* 20px */;
  line-height: 1.75rem /* 28px */;
}
.detail__item .item__data {
  display: grid;
  justify-content: flex-end;
  align-content: center;
  text-align: right;
}
.detail__item .item__data .data__contnet--value {
  font-size: 1.25rem /* 20px */;
  line-height: 1.75rem /* 28px */;
}
.detail__item .item__data .data__contnet--reference {
  font-size: 0.875rem /* 14px */;
  line-height: 1.25rem /* 20px */;
}
</style>
